<template>
    <select class="form-control dropdown-bigger" @change="changeType($event.target.value)" v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)">
        <option selected>Choose type</option>
        <option :key="type.id" :value="type.id" v-for="type in types">{{type.name}}</option>
    </select>
</template>
<script>
    export default {
        data() {
            return {
                types: []
            }
        },
        props: ['value', 'allTypes', 'customer'],
        async mounted() {
            if (this.allTypes) {
                this.types = await this.$store.dispatch('DROPDOWN_TYPES')
            }
        },
        methods: {
            changeType(controlInterval) {
                if (this.allTypes) {
                    let interval = ''
                    let max_wear_rate = ''
                    let max_pollution_rate = ''
                    let max_weight_rate = ''
                    let min_weight_rate = ''
                    let max_back_pressure_rate = ''
                    let min_back_pressure_rate = ''
                    let max_leakage_rate = ''
                    let min_leakage_rate = ''

                    this.types.forEach(function (element) {
                        if (element.id == controlInterval) {
                            interval = element.interval_control
                            max_wear_rate = element.max_wear_rate
                            max_pollution_rate = element.max_pollution_rate
                            max_weight_rate = element.max_weight_rate
                            min_weight_rate = element.min_weight_rate
                            max_back_pressure_rate = element.max_back_pressure_rate
                            min_back_pressure_rate = element.min_back_pressure_rate
                            max_leakage_rate = element.max_leakage_rate
                            min_leakage_rate = element.min_leakage_rate
                        }
                    })

                    this.$parent.form.interval_control = interval
                    this.$parent.form.max_wear_rate = max_wear_rate
                    this.$parent.form.max_pollution_rate = max_pollution_rate
                    this.$parent.form.max_weight_rate = max_weight_rate
                    this.$parent.form.min_weight_rate = min_weight_rate
                    this.$parent.form.max_back_pressure_rate = max_back_pressure_rate
                    this.$parent.form.min_back_pressure_rate = min_back_pressure_rate
                    this.$parent.form.max_leakage_rate = max_leakage_rate
                    this.$parent.form.min_leakage_rate = min_leakage_rate
                }
            },
            async loadCustomerType(customerId){
                this.types = await this.$store.dispatch('DROPDOWN_TYPES_CUSTOMER', customerId)
            }
        },
        watch: {
            customer: function(newVal, oldVal) { // watch it
                this.loadCustomerType(newVal)
            }
        }
    }
</script>
<style>
    .dropdown-bigger {
        padding: .75rem;
    }
</style>
